'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('react');
var taggedTemplateLiteral = require('../../taggedTemplateLiteral-f923b98d.js');
require('styled-components');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');

function _templateObject2() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    -webkit-appearance: none; /* stylelint-disable-line property-no-vendor-prefix */\n    text-size-adjust: 100%;\n    border-color: initial;\n    border-image: initial;\n    border-style: initial;\n    border-width: 0;\n    font-weight: inherit;\n    outline: 0;\n    padding: 0;\n    text-rendering: optimizeLegibility;\n  }\n\n  body {\n    font-family: 'Graphik-Regular','Gotham SSm A','Gotham SSm B','Helvetica Neue',Helvetica,Arial,sans-serif !important;\n  }\n\n  ol, ul {\n    list-style: none;\n  }\n\n  a {\n    text-decoration: none;\n    color: inherit;\n  }\n\n  /* Input reset CSS */\n  /* Firefox */\n  input:invalid {\n    box-shadow: none;\n  }\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  textarea:-webkit-autofill,\n  textarea:-webkit-autofill:hover,\n  textarea:-webkit-autofill:focus,\n  select:-webkit-autofill,\n  select:-webkit-autofill:hover,\n  select:-webkit-autofill:focus {\n    border-color: var(--inputCurrentColor);\n    -webkit-text-fill-color: var(--inputCurrentColor);\n    -webkit-box-shadow: 0 0 0px 1000px white inset !important; /* stylelint-disable-line property-no-vendor-prefix */\n  }\n\n  input[type='number'] {\n    appearance: none;\n  }\n\n  input[type='tel'] {\n    appearance: textfield;\n  }\n\n  input[type='number']::-webkit-inner-spin-button,\n  input[type='number']::-webkit-outer-spin-button {\n    appearance: none;\n    margin: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
function createFontFaceSRC(_ref) {
  var url = _ref.url,
      format = _ref.format;
  return "url('".concat(url, "') format('").concat(format, "')");
}
function joinFontFaceSRC() {
  var sources = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return sources.map(createFontFaceSRC).join(',');
}
function createFontFaces(_ref2) {
  var typography = _ref2.typography;
  return typography.map(function (_ref3) {
    var fontFamily = _ref3.fontFamily,
        sources = _ref3.sources;
    return "\n      @font-face {\n        font-family: ".concat(fontFamily, ";\n        src: ").concat(joinFontFaceSRC(sources), ";\n        font-style: normal;\n        font-display: swap;\n      }\n    ");
  }).join('');
}
var GlobalFonts = xstyledStyledComponents_es.createGlobalStyle(_templateObject(), function (props) {
  return createFontFaces(props.theme);
});
var GlobalStyle = xstyledStyledComponents_es.createGlobalStyle(_templateObject2());

exports.GlobalFonts = GlobalFonts;
exports.createFontFaceSRC = createFontFaceSRC;
exports.createFontFaces = createFontFaces;
exports.default = GlobalStyle;
exports.joinFontFaceSRC = joinFontFaceSRC;
//# sourceMappingURL=GlobalStyle.js.map
